import { useAccountStore } from '@/stores/account.js';
import { defineChannelAccountStore } from '@/stores/channelAccount.js';

// The Shopify store link the /shopify/* analytics pages read. Rows come from the
// integration service's connections list (link id, shop name / domain, derived status);
// the id travels to olap as the Shopifylinkid header.
//
// Links olap can read are offered: the link itself must be ACTIVE (a DISCONNECTED link is a
// 403 — a store is shared and keeps syncing for the other business profiles, so an unlinked
// profile must lose access). An uninstalled shop (derived status REVOKED) stays readable
// while this profile's own link is still ACTIVE, until shop/redact erases it (owner
// 2026-10-13); the connections list's raw `linkStatus` tells it from an unlinked one.
export const isReadableShopifyLink = (link) =>
  link?.status === 'ACTIVE' || (link?.status === 'REVOKED' && link?.linkStatus === 'ACTIVE');

export const fetchReadableShopifyLinks = async () =>
  ((await useAccountStore().fetchShopifyConnections()) || []).filter(isReadableShopifyLink);

export const useShopifyLinkStore = defineChannelAccountStore('shopifyLink', {
  storagePrefix: 'wp.shopify.selectedLink',
  fetchAccounts: fetchReadableShopifyLinks,
});

// A store's display name: its shop name, else its myshopify domain, else the link id.
export const shopifyLinkLabel = (link) =>
  link?.shopName || link?.shopDomain || (link?.id != null ? `#${link.id}` : '');
